import { Layout } from '@screens/offers/NewOfferForm/OfferForm/OfferSections/elements/components/GalleryElement/consts';

const GalleryElementModel = {
  elements: [],
  layout: Layout.DEFAULT,
};

export default GalleryElementModel;
